import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../Auth/auth.service';
import { MediaFile, ConfigStrings, ErrorCodes, MediaTranslation } from 'src/app/utils/common-classes';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  public getFiles(mediaFolderId: string): Promise<Array<MediaFile>> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      let params = new HttpParams();
      params = params.append('mediaFolderId', mediaFolderId);

      _self.httpClient.get(ConfigStrings.API_URL + "/get-files", { headers: headers, params: params }).subscribe((data: Array<MediaFile>) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public createFile(mediaFile: MediaFile): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/create-file", mediaFile, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public editFile(mediaFile: MediaFile): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-file", mediaFile, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public renameFile(mediaFile: MediaFile) {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-file", mediaFile, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public deleteFile(mediaFile: MediaFile): Promise<void> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/delete-file", mediaFile, { headers: headers }).subscribe(() => {
        resolve();
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public editPreview(mediaFile: MediaFile): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-file-preview", mediaFile, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }
  
  public editPreviewTmp(mediaFile: MediaFile): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-file-preview-tmp", mediaFile, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public setFileTranslation(mediaTranslation: MediaTranslation): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/set-file-translation", mediaTranslation, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public deleteTranslation(mediaTranslation: MediaTranslation): Promise<MediaFile> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/delete-file-translation", mediaTranslation, { headers: headers }).subscribe((data: MediaFile) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }
  //todo delete
  public getFilePreviews(): Promise<Array<MediaFile>> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.get(ConfigStrings.API_URL + "/get-file-previews", { headers: headers }).subscribe((data: Array<MediaFile>) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }
}
